import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiDtgUserService
    ,FvmsApiDtgCarService
    ,FvmsApiDtgTeamService
    ,FvmsApiAuthService
    ,FvmsExcelService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import {DtgManageScheduleDriveFormComponent} from '../form/dtg.manage.schedule.drive.form.component';
import addDays from 'date-fns/addDays';
import {format} from 'date-fns';
import {DtgManageScheduleDriveDeleteComponent} from '../delete/dtg.manage.schedule.drive.delete.component';
import {DtgManageScheduleDriveRegistComponent} from '../regist/dtg.manage.schedule.drive.regist.component';

@Component({
    selector: "dtg-manage-schedule-drive-list"
    ,templateUrl: './dtg.manage.schedule.drive.list.component.html'
    ,styleUrls: ["./dtg.manage.schedule.drive.list.component.scss"]
    ,providers: []
})
export class DtgManageScheduleDriveListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    pagingInfo:PagingInfo = new PagingInfo();
    listUserCarRun:any[];
    columnsUserCarRun:any[];
    @Input() listType:DtgListType = DtgListType.list;
    searchValue:string;
    userGroupId:number;
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    selectedYear:any = '2021';
    selectedMonth:number = 0;
    selectedDate:any;
    listYear:number[] = [];
    listMonth:number[] = [];

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgUserService:FvmsApiDtgUserService
        ,private fvmsApiDtgCarService:FvmsApiDtgCarService
        ,private fvmsApiDtgTeamService:FvmsApiDtgTeamService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsExcelService:FvmsExcelService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        this.pagingInfo.pageSize = 15;

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.pagingInfo.curPage = 1;
                this.reloadListItem();
        });
        for(let a=2020;a<2100;a++){
            this.listYear.push(a);
        }
        for(let a=1;a<13;a++){
            this.listMonth.push(a);
        }

        let tmpDateInfo = this.fvmsCommonService.getDateInfo();
        if(tmpDateInfo && tmpDateInfo.fromDate){
            this.selectedYear = tmpDateInfo.fromDate.year;
            this.selectedMonth = tmpDateInfo.fromDate.month;
        }else{
            let today = new Date();
            this.selectedYear = today.getFullYear();
            this.selectedMonth = today.getMonth() + 1;
        }
     }

    ngOnInit() {
        this.reloadListItem();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {

    }

    clickSearch(){
        this.reloadListItem();
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.reloadListItem();
    }

    exportExcel() {
        this.fvmsCommonService.setIsLoading(true);
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            // ,dtgCarType : this.dtgCarType
            ,searchYear: this.selectedYear?this.selectedYear:null
            ,searchMonth: this.selectedMonth?this.selectedMonth:null
            ,searchValue : this.searchValue
            // ,useYn : this.useYn
        };

        let paging = new PagingInfo();
        paging.pageSize=999999;
        this.fvmsApiDtgUserService.getListUserCarRun(searchInfo,paging)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    let listItems = apiResponse.resultValue;
                    let listJson = this.convertExcelJson(listItems);
                    this.fvmsExcelService.excelDownload(listJson,"list_dispatching_info");
                    this.fvmsCommonService.setIsLoading(false);
                }
            });
    }

    // 배차정보 등록/수정 Component 오픈
    clickOpenModalUserCarRunInfo(dtgActionType: DtgActionType, item: any) {
        let modalRef = this.modalService.open(
            DtgManageScheduleDriveFormComponent
            ,{
                centered:true
                // ,size: "lg"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.companyId = item?.companyId || this.companyInfo.companyId;
        modalRef.componentInstance.userId = item?.userId;
        modalRef.componentInstance.userCarRunId = item?.userCarRunId;
        modalRef.componentInstance.dtgUnitId = item?.dtgUnitId;

        modalRef.result.then((resultModal) => {
            switch(dtgActionType){
                case DtgActionType.create:
                    if(resultModal.result === "ok"){
                        this.reloadListItem();
                    }
                    break;
                case DtgActionType.update:
                    if(resultModal.result === "ok"){
                        this.reloadListItem();
                    }
                    break;
                case DtgActionType.delete:
                    if(resultModal.result === "ok"){
                        this.reloadListItem();
                    }
                    break;
                default:
                    break;
            }
        });
    }

    // 배차정보 등록/수정 Component 오픈
    clickOpenModalRegistUserCarRunInfo(dtgActionType: DtgActionType, item: any) {

        let modalRef = this.modalService.open(
            DtgManageScheduleDriveRegistComponent
            ,{
                centered:true
                ,size: "sm"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.companyId = item?.companyId || this.companyInfo.companyId;
        modalRef.componentInstance.userId = item?.userId || this.currentUserInfo.userId;
        modalRef.componentInstance.userCarRunId = item?.userCarRunId;
        modalRef.componentInstance.dtgUnitId = item?.dtgUnitId;

        modalRef.result.then((resultModal) => {
            switch(dtgActionType){
                case DtgActionType.create:
                    if(resultModal.result === "ok"){
                        this.reloadListItem();
                    }
                    break;
                case DtgActionType.update:
                    if(resultModal.result === "ok"){
                        this.reloadListItem();
                    }
                    break;
                case DtgActionType.delete:
                    if(resultModal.result === "ok"){
                      this.reloadListItem();
                    }
                    break;
                default:
                    break;
            }
        });
    }

    // 배차정보 삭제 Component 오픈
    clickOpenModalDeleteUserCarRun(dtgActionType: DtgActionType) {

        let modalRef = this.modalService.open(
            DtgManageScheduleDriveDeleteComponent
            ,{
                centered:true
                // ,size: "lg"
                ,backdrop:"static"
                // ,windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.companyId = this.companyInfo?.companyId || 0;

        modalRef.result.then((resultModal) => {
            switch(dtgActionType){
                case DtgActionType.create:
                case DtgActionType.update:
                case DtgActionType.delete:
                    if(resultModal.result === "ok"){
                        this.reloadListItem();
                    }
                    break;
                default:
                    break;
            }
        });

    }

    clickDeleteUserCarRun() {
        let checkedIds = [];
        this.listUserCarRun.forEach(x => {
            if (x.selected) {
                checkedIds.push(x.userCarRunId);
            }
        });

        if (checkedIds.length <= 0) {
            alert("배차기록을 선택해 주세요.")
            return;
        }else if( !confirm("선택하신 배차기록을 삭제하시겠습니까?")) {
            return;
        }

        this.fvmsApiDtgUserService.deleteUserCarRun(checkedIds)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    alert(checkedIds.length + "건의 배차기록이 삭제되었습니다.")
                    this.reloadListItem();
                } else {
                    alert("일정 삭제중 오류가 발생하였습니다.");
                    this.reloadListItem();
                }
            });
    }

    isSelectAllUserCarRun() {
        if (!this.listUserCarRun || this.listUserCarRun.length<=0) {
            return false;
        }
        return this.listUserCarRun.every(p => (p && p.selected));
    }

    changeUserCarRunSelectAll(e) {
        this.listUserCarRun.forEach(x => x.selected = e.target.checked);
    }

    reloadListItem(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            // ,dtgCarType : this.dtgCarType
            ,searchYear: this.selectedYear?this.selectedYear:null
            ,searchMonth: this.selectedMonth?this.selectedMonth:null
            ,searchValue : this.searchValue
            // ,useYn : this.useYn
        };
        this.fvmsApiDtgUserService.getListUserCarRun(searchInfo, this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listUserCarRun = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                }
            });
    }

    changeDate(){
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth,1,0,0,0,0);
        dtTo = addDays(dtTo,-1);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd 00:00:00");
        let searchDateTo = format(dtTo,"yyyy-MM-dd 23:59:59");
        this.selectedDate = {
            searchDateFrom:searchDateFrom
            ,searchDateTo:searchDateTo
        };
    }

    changeYear(e){
      this.changeDate();
      this.clickSearch();
    }

    changeMonth(e){
      this.changeDate();
      this.clickSearch();
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }


    convertExcelJson(dataList:any[]){
        return dataList.map((v,i) => {
            return {
                "차량명":v.dtgCarNo || "미설정"
                ,"운전자":v.userNm || "미설정"
                ,"시작운행일":v.dtgRegDtFromDate || "미설정"
                ,"시작운행시간":v.dtgRegDtFromTime || "미설정"
                ,"종료운행일":v.dtgRegDtToDate || "미설정"
                ,"종료운행시간":v.dtgRegDtToTime || "미설정"
                ,"노선번호":v.drivePathNm || "미설정"
                ,"기점":v.drivePathFromNm || "미설정"
                ,"종점":v.drivePathToNm || "미설정"
            };
        });
    }

}
